require('./src/iso-3166-country-codes-angular.js');
module.exports = 'iso-3166-country-codes';
